import { useNavigate } from 'react-router-dom'
import { apiURL } from '../../../utilities/URLs'
import { customerData } from '../../../utilities/CustomerData'
import { refreshAccessToken } from '../../../utilities/extensions'
import { useState } from 'react'

export function AdvancePaymentComplete({ applicationId }) {
  const navigate = useNavigate()
  const [completingApplication, setCompletingApplication] = useState(false)

  const handleCompleteApplication = async () => {
    const form = new FormData()
    setCompletingApplication(true)

    form.append('applicationCompleteInfo', JSON.stringify({
      applicationId: applicationId,
      leadId: customerData.customerLeadData.leadId
    }))

    const completeApplicationResponse = await fetch(`${apiURL}/api/completeApplication`, {
      method: 'PUT',
      headers: {
        'Authorization': customerData.accessToken
      },
      body: form
    })
    const completeApplicationData = await completeApplicationResponse.json()
    setCompletingApplication(false)
    
    if (completeApplicationData.response.error) {
      if (completeApplicationData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleCompleteApplication() : navigate('/', { state: { expired: true } })
      } else
        console.error(completeApplicationData.response.error)
    } else {
      customerData.updateCustomerStage(completeApplicationData.response.newCustomerStageId, completeApplicationData.response.newLeadStageId, completeApplicationData.response.newLeadStageName)
      navigate('/dashboard')
    }
  }

  return (
    <div className='lg:w-screen w-11/12 flex flex-col items-center'>
      <p className='font-bold text-center text-2xl max-sm:text-xl mb-10 max-sm:mb-4'>Advance Payment Complete!</p>
      <p>Congratulations on completeing the applicationf for the Advance Payment Refund! Here are the next steps:</p>
      <ul className='list-disc ml-5 mt-2'>
        <li>Go back to your dashboard to download your documents.</li>
        <li>Make sure all documents in the packet are filled out properly.</li>
      </ul>
      <button
        disabled={completingApplication}
        onClick={handleCompleteApplication}
        className={`px-8 py-2 mt-6 text-white rounded max-sm:mb-4 ${completingApplication ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}>
        Complete
      </button>
      {completingApplication && (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
          <p>Completing Application...</p>
        </div>
      )}
    </div>
  )
}